import { createLoader, parseAsString, parseAsStringLiteral } from 'nuqs';

import { DEALS_SORT_DIRECTIONS, POSTPONED_DEALS_SORT_FIELDS } from '@crm/entities/deal';
import { createIntegerRangeParser } from '@crm/shared/lib';

import { DEALS_TABLE_SORT_FIELDS } from './consts';

import type { UrlKeys } from 'nuqs';

export const DEFAULT_POSTPONED_DEALS_SORT = DEALS_TABLE_SORT_FIELDS.postponedUntil;
export const DEFAULT_POSTPONED_DEALS_DIRECTION = 'asc';

export const postponedDealsSearchParams = {
    page: createIntegerRangeParser({ min: 1 }).withDefault(1),
    query: parseAsString,
    sort: parseAsStringLiteral(POSTPONED_DEALS_SORT_FIELDS),
    direction: parseAsStringLiteral(DEALS_SORT_DIRECTIONS),
    postponedUntilFrom: parseAsString,
    postponedUntilTo: parseAsString,
    lastContactAtFrom: parseAsString,
    lastContactAtTo: parseAsString,
    areaFrom: parseAsString,
    areaTo: parseAsString,
};

export const postponedDealsSearchParamUrlKeys = {
    postponedUntilFrom: 'postponed_until_from',
    postponedUntilTo: 'postponed_until_to',
    lastContactAtFrom: 'last_contact_at_from',
    lastContactAtTo: 'last_contact_at_to',
    areaFrom: 'area_from',
    areaTo: 'area_to',
} satisfies UrlKeys<typeof postponedDealsSearchParams>;

export const loadPostponedDealsSearchParams = createLoader(postponedDealsSearchParams, {
    urlKeys: postponedDealsSearchParamUrlKeys,
});
